'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _swiper = require('swiper/dist/js/swiper.min');

var _swiper2 = _interopRequireDefault(_swiper);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _MPPHeading = require('../../../atoms/heading/jsx/MPPHeading');

var _MPPHeading2 = _interopRequireDefault(_MPPHeading);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'card-carousel';

var htmlToReactParser = new _htmlToReact2.default.Parser();

var CardCarousel = function (_React$Component) {
  _inherits(CardCarousel, _React$Component);

  function CardCarousel(props) {
    _classCallCheck(this, CardCarousel);

    var _this = _possibleConstructorReturn(this, (CardCarousel.__proto__ || Object.getPrototypeOf(CardCarousel)).call(this, props));

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _MPPHeading2.default,
          { level: '2', className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.renderParagraph = function (paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__paragraph pp-sans-big-light' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    };

    _this.state = {
      currentSlide: 0,
      slidesPerView: _this.props.config.options.slidesPerView || 4
    };

    // Preload background images before component renders
    if (typeof window !== 'undefined' && _this.props.content && _this.props.content.items) {
      _this.props.content.items.forEach(function (item) {
        if (item.backgroundImage && item.backgroundImage.src) {
          var img = document.createElement('img');
          img.src = item.backgroundImage.src;
        }
      });
    }

    _this.handleResize = _this.handleResize.bind(_this);
    _this.prevSlide = _this.prevSlide.bind(_this);
    _this.nextSlide = _this.nextSlide.bind(_this);
    _this.updateCarousel = _this.updateCarousel.bind(_this);
    _this.transitionEnd = _this.transitionEnd.bind(_this);
    _this.stopAutoplay = _this.stopAutoplay.bind(_this);
    _this.startAutoplay = _this.startAutoplay.bind(_this);
    return _this;
  }

  _createClass(CardCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initCarousel();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateCarousel();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.swiper) this.swiper.destroy(true, true);
      this.swiper = undefined;
    }
  }, {
    key: 'setPos',
    value: function setPos() {
      this.setState({
        currentSlide: this.swiper.realIndex
      });
    }
  }, {
    key: 'setSlidesPerView',
    value: function setSlidesPerView() {
      this.setState({
        slidesPerView: this.swiper.params.slidesPerView
      });
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      if (this.swiper && this.swiper.params) {
        this.setState({
          slidesPerView: this.swiper.params.slidesPerView
        });
      }
    }
  }, {
    key: 'initCarousel',
    value: function initCarousel() {
      var _props = this.props,
          config = _props.config,
          content = _props.content;
      var options = config.options;
      var items = content.items;

      var self = this;

      Object.assign(options, {
        loop: true,
        on: {
          transitionEnd: self.transitionEnd,
          // fix swiper bug
          // when on first slide and prev is clicked, navigate to last slide
          slidePrevTransitionStart: function slide() {
            if (this.isBeginning === true) {
              this.slideToLoop(items.length - 1);
            }
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        slidesPerView: 4,
        slidesPerGroup: 4,
        breakpoints: {
          782: {
            slidesPerView: 1,
            slidesPerGroup: 1
          },
          997: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          998: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        }
      });

      this.swiper = new _swiper2.default(this.container, options);
      this.setSlidesPerView();
    }
  }, {
    key: 'transitionEnd',
    value: function transitionEnd() {
      // update current position after a transition ends
      if (this.swiper) this.setPos();
    }
  }, {
    key: 'updateCarousel',
    value: function updateCarousel() {
      if (this.swiper) this.swiper.update();
    }
  }, {
    key: 'prevSlide',
    value: function prevSlide(e) {
      e.preventDefault();
      this.swiper.slidePrev();
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide(e) {
      e.preventDefault();
      this.swiper.slideNext();
    }
  }, {
    key: 'stopAutoplay',
    value: function stopAutoplay() {
      if (this.swiper && this.swiper.autoplay.running) {
        this.swiper.autoplay.stop();
      }
    }
  }, {
    key: 'startAutoplay',
    value: function startAutoplay() {
      if (this.swiper && !this.swiper.autoplay.running) {
        this.swiper.autoplay.start();
      }
    }
  }, {
    key: 'renderSlide',
    value: function renderSlide(_ref, i) {
      var headline = _ref.headline,
          paragraph = _ref.paragraph,
          link = _ref.link,
          secondaryButton = _ref.secondaryButton,
          hatchText = _ref.hatchText,
          backgroundImage = _ref.backgroundImage;

      var hasLink = link && link.href;
      return _react2.default.createElement(
        'div',
        {
          /* eslint-disable */
          className: (0, _classnames2.default)(ORGANISM_NAME + '__slide', 'swiper-slide', _defineProperty({}, ORGANISM_NAME + '__slide--active', i === this.state.currentSlide))
          /* eslint-enable */
          , key: headline.text + '_' + i
        },
        _react2.default.createElement(
          'div',
          {
            className: ORGANISM_NAME + '__slide-inner',
            style: {
              backgroundImage: 'url(' + backgroundImage.src + ')',
              backgroundSize: '' + (backgroundImage.size || 'cover'),
              backgroundPosition: (backgroundImage.position || 'center') + ' center'
            }
          },
          hasLink && _react2.default.createElement('a', {
            className: ORGANISM_NAME + '__slide-background-link',
            href: link.href,
            target: link.target ? link.target : '_self'
          }),
          headline && headline.text && _react2.default.createElement(
            _MPPHeading2.default,
            { level: '4', className: ORGANISM_NAME + '__slide-headline' },
            hasLink ? _react2.default.createElement(
              'a',
              { href: link.href, className: ORGANISM_NAME + '__slide-text-link' },
              htmlToReactParser.parse(headline.text)
            ) : htmlToReactParser.parse(headline.text)
          ),
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '__slide-popup' },
            paragraph && paragraph.text && _react2.default.createElement(
              'p',
              { className: ORGANISM_NAME + '__slide-paragraph' },
              hasLink ? _react2.default.createElement(
                'a',
                { href: link.href, className: ORGANISM_NAME + '__slide-text-link' },
                htmlToReactParser.parse(paragraph.text)
              ) : htmlToReactParser.parse(paragraph.text)
            ),
            secondaryButton && secondaryButton.text && _react2.default.createElement(
              _button2.default
              // adding null to prevent empty id from being added to DOM
              ,
              { id: secondaryButton.id || null,
                href: hasLink ? link.href : null,
                color: secondaryButton.color || 'outline-white',
                className: ORGANISM_NAME + '__slide-btn',
                fpti: 'secondaryButton-' + (secondaryButton.fpti || secondaryButton.text),
                target: secondaryButton.target ? secondaryButton.target : '_self'
              },
              secondaryButton.text
            ),
            hatchText && hatchText.text && _react2.default.createElement(
              'p',
              { className: ORGANISM_NAME + '__slide-hatch-text' },
              hasLink ? _react2.default.createElement(
                'a',
                { href: link.href, className: ORGANISM_NAME + '__slide-text-link' },
                htmlToReactParser.parse(hatchText.text)
              ) : htmlToReactParser.parse(hatchText.text)
            )
          )
        )
      );
    }
  }, {
    key: 'renderSlideCounter',
    value: function renderSlideCounter(itemsLength) {
      var currentSlide = this.state.currentSlide;

      var activeSlide = currentSlide >= itemsLength ? 1 : currentSlide + 1;

      return _react2.default.createElement(
        'span',
        {
          className: ORGANISM_NAME + '__slide-counter'
        },
        activeSlide + ' / ' + itemsLength
      );
    }
  }, {
    key: 'renderDotSelectors',
    value: function renderDotSelectors(itemsLength) {
      var _this2 = this;

      var _props2 = this.props,
          config = _props2.config,
          content = _props2.content;
      var trackId = config.trackId;
      var _state = this.state,
          currentSlide = _state.currentSlide,
          slidesPerView = _state.slidesPerView;

      var activeSlide = currentSlide >= itemsLength ? 0 : Math.floor(currentSlide / slidesPerView);
      var numDots = Math.ceil(itemsLength / slidesPerView);
      var items = [];
      var listStyle = {
        display: 'inline-block',
        lineHeight: 0
      };

      var _loop = function _loop(i) {
        var _cx2;

        var isActive = activeSlide === i;
        var selectorClass = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, ORGANISM_NAME + '__dot-selector__button', true), _defineProperty(_cx2, ORGANISM_NAME + '__dot-selector__button--active', isActive), _defineProperty(_cx2, ORGANISM_NAME + '__dot-selector__button--transitioning', _this2.state.isTransitioning), _cx2));

        items.push(_react2.default.createElement(
          'li',
          {
            key: trackId + '-DotSelector-' + i,
            style: listStyle
          },
          _react2.default.createElement('button', {
            'aria-label': content.goToSlide.text + ' ' + i,
            className: selectorClass,
            onClick: function onClick() {
              _this2.swiper.slideToLoop(i * slidesPerView);_this2.setState({ isTransitioning: true });
            },
            'data-pa-click': trackId + '-DotSelector-Slide' + i,
            id: trackId + '-DotSelector-' + i,
            tabIndex: isActive ? -1 : 0
          })
        ));
      };

      for (var i = 0; i < numDots; i += 1) {
        _loop(i);
      }

      return _react2.default.createElement(
        'ul',
        {
          onMouseEnter: this.stopAutoplay,
          onMouseLeave: this.startAutoplay,
          className: ORGANISM_NAME + '__dot-selector'
        },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _cx4,
          _this3 = this;

      var _props3 = this.props,
          content = _props3.content,
          config = _props3.config,
          className = _props3.className;
      var id = config.id,
          trackId = config.trackId,
          theme = config.theme;
      var items = content.items,
          goToPreviousSlide = content.goToPreviousSlide,
          goToNextSlide = content.goToNextSlide,
          headline = content.headline,
          paragraph = content.paragraph;


      var leftClass = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, ORGANISM_NAME + '__arrow', true), _defineProperty(_cx3, ORGANISM_NAME + '__arrow__left', true), _cx3));

      var rightClass = (0, _classnames2.default)((_cx4 = {}, _defineProperty(_cx4, ORGANISM_NAME + '__arrow', true), _defineProperty(_cx4, ORGANISM_NAME + '__arrow__right', true), _cx4));

      return _react2.default.createElement(
        'section',
        { id: id, className: (0, _classnames2.default)(ORGANISM_NAME + '-organism', className, theme) },
        _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + ' container' },
          _react2.default.createElement(
            'div',
            { className: 'swiper-container', ref: function ref(element) {
                _this3.container = element;
              } },
            this.renderHeadline(headline),
            this.renderParagraph(paragraph),
            _react2.default.createElement(
              'div',
              {
                className: 'swiper-wrapper',
                onMouseEnter: this.stopAutoplay,
                onMouseLeave: this.startAutoplay
              },
              items.map(function (item, i) {
                return _this3.renderSlide(item, i);
              })
            )
          ),
          items.length > 1 && _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '-navigation row' },
            _react2.default.createElement(
              'div',
              {
                className: ORGANISM_NAME + '-navigation-column col-lg-4 col-md-6 col-sm-8 col-xs-12'
              },
              _react2.default.createElement('button', {
                'aria-label': goToPreviousSlide.text,
                className: leftClass,
                onClick: this.prevSlide,
                'data-pa-click': trackId + '-LftArrow-Slide' + this.state.currentSlide,
                id: trackId + '-LftArrow-' + this.state.currentSlide,
                tabIndex: this.state.currentSlide === 0 ? -1 : 0
              }),
              this.props.config.renderNumberCounter || items.length > this.props.config.numberCounterThreshold ? this.renderSlideCounter(items.length) : this.renderDotSelectors(items.length),
              _react2.default.createElement('button', {
                'aria-label': goToNextSlide.text,
                className: rightClass,
                onClick: this.nextSlide,
                'data-pa-click': trackId + '-RtArrow-Slide' + this.state.currentSlide,
                tabIndex: this.state.currentSlide + 1 >= this.state.numSlides ? -1 : 0,
                id: trackId + '-RtArrow-' + this.state.currentSlide
              })
            )
          )
        )
      );
    }
  }]);

  return CardCarousel;
}(_react2.default.Component);

exports.default = CardCarousel;


CardCarousel.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    options: _propTypes2.default.shape({
      slidesPerView: _propTypes2.default.number,
      spaceBetween: _propTypes2.default.number,
      autoplay: _propTypes2.default.bool
    }),
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']),
    trackId: _propTypes2.default.string,
    numberCounterThreshold: _propTypes2.default.number,
    renderNumberCounter: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    goToSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    goToNextSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    goToPreviousSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string
      }),
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string
      }),
      link: _propTypes2.default.shape({
        href: _propTypes2.default.string,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }),
      secondaryButton: _propTypes2.default.shape({
        text: _propTypes2.default.string
      }),
      hatchText: _propTypes2.default.shape({
        text: _propTypes2.default.string
      }),
      backgroundImage: _propTypes2.default.shape({
        src: _propTypes2.default.string,
        position: _propTypes2.default.oneOf(['left', 'right', 'center']),
        size: _propTypes2.default.string
      })
    }).isRequired)
  }),
  className: _propTypes2.default.string
};

CardCarousel.defaultProps = {
  config: {
    id: '',
    options: {
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: true
    },
    theme: 'theme-background-color-white',
    trackId: 'Card-Carousel',
    numberCounterThreshold: 20,
    renderNumberCounter: false
  },
  content: {
    goToSlide: {
      text: 'Go to slide group'
    },
    goToNextSlide: {
      text: 'Go to next slide'
    },
    goToPreviousSlide: {
      text: 'Go to previous slide'
    },
    headline: {
      text: 'Fewer than 34 Characters Headline'
    },
    paragraph: {
      text: '140 characters max Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat, neque vero quisquam minus quam quas numquam deleniti dignissimos sunt omnis facilis voluptate delectus, rerum voluptatem recusandae unde consequatur reprehenderit sint.'
    },
    items: [{
      headline: {
        text: '1 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '2 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '3 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '4 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '5 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '6 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }, {
      headline: {
        text: '7 Fewer than 34 Characters'
      },
      paragraph: {
        text: '130 characters max lorem ipsum dolor sic amet'
      },
      link: {
        href: '#'
      },
      secondaryButton: {
        text: 'Secondary Button'
      },
      hatchText: {
        text: 'Less than 28 characters max'
      },
      backgroundImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/okm/us/business-resource-center/images/checkout-comparison-ppxo/checkout-comparison-375x375.jpg',
        position: 'center'
      }
    }]
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/card-carousel/jsx/CardCarousel.js
// module id = 1072
// module chunks = 4